var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 97,
    viewBox: "0 0 75 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4462 3V3C44.8652 3 47.1849 3.96134 48.8948 5.67235L69.8401 26.6315C71.3068 28.0992 72.1307 30.0892 72.1307 32.1641V32.1641M42.4462 3H12.6418C7.34268 3 3.04688 7.29582 3.04688 12.595V83.5978C3.04688 88.8969 7.34269 93.1927 12.6418 93.1927H62.5357C67.8349 93.1927 72.1307 88.8969 72.1307 83.5978V32.1641M42.4462 3V22.5691C42.4462 27.8683 46.742 32.1641 52.0412 32.1641H72.1307",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 56.7319H49.1003M22.2344 64.4079H49.1003M22.2344 72.0839H33.7483",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.e9be51b4137bbf34711cb873156f892a.svg";
export { ForwardRef as ReactComponent };